import axios from 'axios';

import { ResponseObj, HistoricoRespostaFormData } from '../../../back/src/types';
import { Historico } from '../../../back/src/entity/Historico';
import { HistoricoResposta } from '../../../back/src/entity/HistoricoResposta';

const historicoFinalizar = async (
  formData: { historicoId: number },
): Promise<ResponseObj<Historico>> => {
  const res = await axios.put<ResponseObj<Historico>>('historicos/finalizar', formData);
  return res.data;
};

const historicosRespostas = async (
  formData: HistoricoRespostaFormData[],
): Promise<ResponseObj<HistoricoResposta[]>> => {
  const res = await axios.put<ResponseObj<HistoricoResposta[]>>('historicos_respostas', formData);
  return res.data;
};

export default {
  historicoFinalizar,
  historicosRespostas,
};
